export const isSupported = (fileType: string, suppertedTypes: string[]) => {
    const result = suppertedTypes.find(type => fileType === type);

    return !!result;
};

export const checkFile = (
    file: File | null,
    sizeInK: number,
    supportedFileTypes: string[] | "all",
    setMessageError: (message: string) => void
): boolean => {
    setMessageError("");
    if (!file) {
        return false;
    }
    const isSupportedType =
        supportedFileTypes === "all" ||
        isSupported(file.type, supportedFileTypes);

    if (!isSupportedType) {
        setMessageError("file not supported");
        return false;
    }

    const isCorrectSize = file.size / 1024 < sizeInK;
    if (!isCorrectSize) {
        setMessageError(`File must smaller than ${sizeInK}Kb!`);
        return false;
    }

    return true;
};
